export class PrintInfo {

  header: string;
  footer: string;
  includeDataTables: boolean;
}
